import Box from '@material-ui/core/Box';

export default Box;
